/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React, {
    Fragment,
    useEffect,
    useState,
} from 'react';
import PropTypes from 'prop-types';

import FormInput from '../FormInput/FormInput';
import FormLabel from '../FormLabel/FormLabel';
import Icon from '../../../Icon/Icon';
import Row from '../../../Row/Row';

import {
    commonDefaultProps,
    commonPropTypes,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    emptyContent: PropTypes.any,
    fileName: PropTypes.string,
    name: PropTypes.string.isRequired,
    resetable: PropTypes.bool,
    value: PropTypes.any,
    withPreview: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: Fragment,
    emptyContent: 'Glissez & déposez ici',
    fileName: '',
    resetable: true,
    value: '',
    withPreview: false,
};

const FormInputFile = (props) => {
    const [hovered, setHovered] = useState(false);
    const [valueSrc, setValueSrc] = useState(props.value);

    useEffect(() => {
        if (!props.value) {
            setValueSrc(null);
        } else if (typeof props.value === 'object') {
            const reader = new FileReader();
            reader.readAsDataURL(props.value);
            reader.onload = (e) => {
                setValueSrc(e.target.result);
            };
        } else if (typeof props.value === 'string') {
            setValueSrc(props.value);
        }
    }, [props.value]);

    const dragEnter = () => {
        setHovered(true);
    };

    const dragLeave = () => {
        setHovered(false);
    };

    const renderPreview = () => {
        if (hovered) {
            return (
                <Row noCol hcenter vcenter style={{ width: '100%', height: '100%' }}>
                    <img src="/images/file-import.svg" alt="Drag and drop hover" />
                </Row>
            );
        }
        if (!props.value || !props.withPreview) {
            return null;
        }
        return (
            <img
                src={valueSrc}
                className="c-form-field__fileupload-preview"
                alt="Input file preview"
                style={{
                    maxWidth: '100px',
                    maxHeight: '100px',
                    marginLeft: '10px',
                }}
            />
        );
    };

    const renderContent = () => {
        if (hovered) {
            return null;
        }
        if (!props.value) {
            return (
                <span className="c-form-field__fileupload-info">
                    {props.emptyContent}
                </span>
            );
        } if (!props.resetable) {
            return (
                <>
                    <span className="c-form-field__fileupload-filename">
                        {props.fileName}
                    </span>
                    <span className="c-form-field__fileupload-reset" style={{ zIndex: 0 }}>
                        <Icon collection="yp" icon="edit" onClick={props.onReset} />
                    </span>
                </>
            );
        }
        return (
            <>
                <span className="c-form-field__fileupload-filename">
                    {props.fileName}
                </span>
                <span className="c-form-field__fileupload-reset">
                    <Icon collection="yp" icon="close" onClick={props.onReset} />
                </span>
            </>
        );
    };

    return (
        <>
            <FormInput
                type="file"
                autoComplete="off"
                onDragEnter={dragEnter}
                onDragOver={dragEnter}
                onDragLeave={dragLeave}
                onDragEnd={dragLeave}
                onDrop={dragLeave}
                {...filterProps(propTypes, props)}
            />
            <FormLabel
                htmlFor={props.name}
                className={hovered ? 'c-form__label_hovered' : ''}
            >
                {renderPreview()}
                {renderContent()}
            </FormLabel>
        </>
    );
};

FormInputFile.propTypes = propTypes;

FormInputFile.defaultProps = defaultProps;

export default FormInputFile;
